<div class="" style="width: 100%; display: flex; justify-content: center;">
    <div style="background: rgb(230, 230, 230); padding: 5px;">
        <p>Authorize</p>
        <div style="display: block;">
            <label for="login">Login</label>
            <br>
            <input name="login" type="text" [(ngModel)]="loginModel.login">
        </div>
        <div>
            <label for="password">Password</label>
            <br>
            <input type="password" [(ngModel)]="loginModel.password">
        </div>
        <div style="display: flex; justify-content: center; margin: 5px 0px;">
            <button (click)="login()">Войти</button>
        </div>
    </div>
</div>